import { useSelector } from "react-redux";
import type { RootState } from "state/rootReducer";
import type { ProjectConfigState } from "state/config/reducer";

export const useConfigMapBase = (): Record<string, ProjectConfigState> => {
  const configMap = useSelector((state: RootState) => state.configMap.defaultConfigById ?? {});
  return configMap;
};
